<img
  src="../../../../assets/images/animated_success.gif"
  alt="check de sucesso"
  width="200px"
  height="200px"
/>
<h1>Os dados da loja foram atualizados!</h1>
<h2>
  Mantenha os contatos da loja sempre atualizados para receber nossas
  comunicações.
</h2>
